import { ProductType } from '@annunciate/core';
export const getLabelFromProductType = (type) => {
    switch (type) {
        case ProductType.RECURRING:
            return 'Subscribe';
        case ProductType.RENTAL:
            return 'Rent';
        case ProductType.ONETIME:
        default:
            return 'Buy';
    }
};
//# sourceMappingURL=getLabelFromProductType.js.map